<ng-template #spinner2>
   <mat-spinner diameter="24" class="common-t7l5 common-inlineblock"></mat-spinner>
</ng-template>

<div class="title" color="primary">
   <button mat-icon-button routerLink="..">
      <mat-icon>arrow_back</mat-icon>
   </button>

   <div class="ellipsis">Account #{{account.number}} - {{account.name}}</div>
</div>

<div class="message mat-error" *ngIf="account.override">Override active</div>
<div class="message" *ngIf="account.message">{{account.message}}</div>
<div class="message mat-error" *ngIf="error">{{error}}</div>

<ng-container *ngIf="payments">
   <form [formGroup]="paymentForm">
      <ng-container formArrayName="payments" *ngFor="let item of payments.controls; index as i; last as last">
         <div @newLine [formGroupName]="i" class="flex">
            <mat-form-field>
               <input matInput #inv placeholder="Invoice Number" formControlName="id" autocomplete="off" />
               <mat-error libInputErrors [control]="item.get('id')"></mat-error>
            </mat-form-field>

            <mat-form-field floatLabel="always">
               <input matInput formControlName="amount" autocomplete="off" />
               <mat-label>Amount</mat-label>
               <span matPrefix>{{ this.currency | currencysymbol }}</span>
               <span matSuffix class="common-ml1ex">{{this.currency}}</span>
               <mat-error libInputErrors [control]="item.get('amount')"></mat-error>
               <mat-hint *ngIf="payments.at(i).get('amount').value" align="end">Max {{account.prefs.line_item_max | currencycode : this.currency}}</mat-hint>
            </mat-form-field>
         </div>
      </ng-container>

      <div class="message mat-error" *ngIf="payments.length >= max"> You have reached the maximum number of entries allowed</div>

      <ng-container *ngIf="notes">
         <button mat-button class="note-button" (click)="notes.reset(); ( notes.enabled ? notes.disable() : notes.enable() )">
            <mat-icon>{{ notes.enabled ? 'remove' : 'add' }}</mat-icon> Note
         </button>

         <div @noteSwitch *ngIf="notes.enabled">
            <mat-form-field class="common-w100perc">
               <textarea matInput formControlName="notes"></textarea>
            </mat-form-field>
         </div>
      </ng-container>

      <ng-container *ngIf="total">
         <div class="mumbo">
            {{account.name}} understands that by submitting a payment request on this website, {{account.name}} hereby authorizes {{theme.currentTheme.name}} to charge specified credit card for the total amount provided. This payment will be applied against the invoices listed, for account #{{account.number}}.
         </div>

         <div *ngIf="error" class="message mat-error">{{error}}</div>

         <div @newLine class="flex">
            <div>
               <button #pay_button mat-raised-button color="primary" type="submit" (click)="pay()" [disabled]="paymentForm.invalid" *ngIf="!loading else spinner2">Pay Now</button>
            </div>

            <div><span color="primary">Total</span> {{total | currencycode : this.currency}}</div>
         </div>
      </ng-container>
   </form>
</ng-container>
